import { SeatComfort, FlightClass } from '@websky/graphql';
import { getMinPrice } from '../../../../utils';
import { getSeatPrice } from './getSeatPrice';
export function getGroupServices(rows) {
    const seatsByComfortMap = new Map();
    const seatsByServiceClassMap = new Map();
    rows.forEach(row => {
        var _a;
        (_a = row.seats) === null || _a === void 0 ? void 0 : _a.forEach(seat => {
            var _a, _b;
            const comfort = (_a = seat.seatService) === null || _a === void 0 ? void 0 : _a.comfort;
            if (comfort) {
                seatsByComfortMap.set(comfort, [...((_b = seatsByComfortMap.get(comfort)) !== null && _b !== void 0 ? _b : []), seat]);
            }
        });
    });
    seatsByComfortMap.forEach(seatsByComfort => {
        seatsByComfort.forEach(seat => {
            var _a, _b;
            const serviceClass = (_a = seat.seatService) === null || _a === void 0 ? void 0 : _a.serviceClass;
            seatsByServiceClassMap.set(serviceClass, [...((_b = seatsByServiceClassMap.get(serviceClass)) !== null && _b !== void 0 ? _b : []), seat]);
        });
    });
    return [...seatsByServiceClassMap.values()].map(seatsByClass => {
        var _a, _b, _c, _d, _e;
        const seatsWithService = seatsByClass.filter(seat => { var _a; return (_a = seat.seatServices) === null || _a === void 0 ? void 0 : _a.length; });
        const seat = seatsByClass[0];
        const rfics = (_a = seat === null || seat === void 0 ? void 0 : seat.rfisc) !== null && _a !== void 0 ? _a : '';
        const serviceClass = (_c = (_b = seat === null || seat === void 0 ? void 0 : seat.seatService) === null || _b === void 0 ? void 0 : _b.serviceClass) !== null && _c !== void 0 ? _c : FlightClass.Economy;
        const comfort = (_e = (_d = seat === null || seat === void 0 ? void 0 : seat.seatService) === null || _d === void 0 ? void 0 : _d.comfort) !== null && _e !== void 0 ? _e : SeatComfort.Standard;
        const minPrice = getMinPrice(seatsWithService, seat => {
            return getSeatPrice(seat);
        });
        return {
            rfics,
            comfort,
            serviceClass,
            minPrice
        };
    });
}
